import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export var TextListVariants;

(function (TextListVariants) {
  TextListVariants["ul"] = "ul";
  TextListVariants["ol"] = "ol";
  TextListVariants["dl"] = "dl";
})(TextListVariants || (TextListVariants = {}));

export var TextList = function TextList(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? TextListVariants.ul : _a$component,
      props = __rest(_a, ["children", "className", "component"]);

  var Component = component;
  return React.createElement(Component, Object.assign({}, props, {
    "data-pf-content": true,
    className: css(className)
  }), children);
};